// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 2V20H7V9H12V20H15V5H20V20H22V22H2V2H4Z"}}]};

const ChartBarFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-bar-filled',
    ref,
    icon: element,
  },
));

ChartBarFilledIcon.displayName = 'ChartBarFilledIcon';

export default ChartBarFilledIcon;
